import { useSession } from '@tgtg/core/session';
import Loader from 'common/splash/Loader';
import { Navigate, Outlet, useLocation } from 'react-router';

const RequireAuth = () => {
  const { session, isInitialized } = useSession();
  const location = useLocation();

  // Show loader while session is being determined
  if (!isInitialized) {
    return <Loader testId='auth-loader' />;
  }

  if (!session.isAuthenticated) {
    // Redirect to login, preserving the attempted URL for post-login redirect
    return <Navigate to='/login' state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default RequireAuth;
